<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import positionNegativeColor from "@/components/positive-negative-color";

import {getEquityOverview, getProfitOverview, getLeverageOverview, getInterestOverview, getInterestRateYearly,getFundingRateYearly,getInterestList,getNetPositiontList, getBasisList, getBasisQuarter} from '@/api/user'
// import positionNegativeColor from '../../../../components/position-negative-color.vue';

/**
 * Starter component
 */
export default {
  page: {
    title: "账户概览",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, },
  props: {
    updating1: {
      type: Boolean,
    },
    updating2: {
      type: Boolean,
    },
  },
  data() {
    return {
      items: [
        {
          text: "Utility",
          href: "/"
        },
        {
          text: "Starter Page",
          active: true
        }
      ],
      chartData: null,
      trade_perPage: 1,
      trade_pageOptions: [1, 3, 7, 15, 30],
      title: "账户汇总",
      usdt_profit_list: [],
      btc_profit_list: [],
      eth_profit_list: [],
      // profit_fields: [],
      leverage_list: [],
      equity_list: [],
      interest_list: [],
      interest_rate_list: [],
      funding_rate_list: [],
      av_interest_rate_list: [],
      net_position_list: [],
      basis_data: [],
      basis_perPage: "当季交割",
      basis_pageOptions: ["当季交割", "次季交割", "永续"],
      interval_perPage: "2h",
      interval_pageOptions: ["1h", "2h", "4h", "1d"],
      coin: "BTC",
      coinOptions: ["BTC", "ETH"],
      // basis_list: [],
      net_position_field: [
        {
          key: "alias",
          sortable: true
        },
        {
          key: "long_pv",
          sortable: true
        },
        {
          key: "short_pv",
          sortable: true
        },
        {
          key: "long-short",
          sortable: true
        },
        {
          key: "long-short（%）",
          sortable: true
        },
      ],
      av_rate_field: [
        {
          key: "exchange",
        },
        {
          key: "1day",
        },
        {
          key: "3day",
        },
        {
          key: "7day",
        },
        {
          key: "15day",
        },
        {
          key: "30day",
        },
      ],
      rate_field: [
      {
          key: "alias",
          sortable: true
        },
        {
          key: "总杠杆率",
          sortable: true
        },
        {
          key: "1day(APR)",
          sortable: true
        },
        {
          key: "3day(APR)",
          sortable: true
        },
        {
          key: "7day(APR)",
          sortable: true
        },
        {
          key: "15day(APR)",
          sortable: true
        },
        {
          key: "30day(APR)",
          sortable: true
        },
      ],
      interest_fields: [
      {
          key: "alias",
          sortable: true
        },
        {
          key: "equity_usdt",
          sortable: true
        },
        {
          key: "interest",
          sortable: true
        },
        {
          key: "funding_profit",
          sortable: true
        },
        {
          key: "total",
          sortable: true
        },
        {
          key: "interest/equity",
          sortable: true
        },
        {
          key: "funding/equity",
          sortable: true
        },
        {
          key: "total/equity",
          sortable: true
        }
      ],
      equity_fields: [
      {
          key: "alias",
          sortable: true
        },
        {
          key: "equity",
          sortable: true
        },
        {
          key: "borrowed_amount",
          sortable: true
        },
        {
          key: "free_amount",
          sortable: true
        },
        {
          key: "margin_available",
          sortable: true
        },
        {
          key: "borrow_limit",
          sortable: true
        },
        {
          key: "yearlyInterest",
          sortable: true
        }
      ],
      profit_fields: [
      {
          key: "alias",
          sortable: true
        },
        {
          key: "本金",
          sortable: true
        },
        {
          key: "最新净值",
          sortable: true
        },
        {
          key: "MMR",
          sortable: true
        },
        {
          key: "总杠杆率",
          sortable: true
        },
        {
          key: "借贷率",
          sortable: true
        },
        {
          key: "累计收益率（APR）",
          sortable: true
        },
        {
          key: "瞬时收益率（APR）",
          sortable: true
        },
        {
          key: "1天收益率（APR）",
          sortable: true
        },
        {
          key: "3天收益率（APR）",
          sortable: true
        }
      ],
      leverage_fields: [
      {
          key: "alias",
          sortable: true
        },
        {
          key: "最新净值",
          sortable: true
        },
        {
          key: "总杠杆率",
          sortable: true
        },
        {
          key: "MMR",
          sortable: true
        },
        {
          key: "margin_ratio",
          sortable: true
        },
        {
          key: "coin_future_ratio",
          sortable: true
        },
        {
          key: "usdt_future_ratio",
          sortable: true
        }
      ],
    };
  },
  filters: {
    formatNumber(value) {
      console.log(value)
      console.log(typeof value)
      if (typeof value !== 'number') return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  computed: {
  positiveNegativeColor() {
    return (field, value) => {
      if (value > 0) {
        return "palegreen";
      } else if (value < 0) {
        return "darkred";
      } else {
        return "";
      }
    };
  }
 },

  methods: {
    onResize(e) {
      this.chartData = this.$echarts.init(document.getElementById('usdt_equityChart'),'dark')
      this.chartData.resize()
    },
    onResizeBasis(e) {
      this.chartDataBasis = this.$echarts.init(document.getElementById('basisChart'),'dark')
      this.chartDataBasis.resize()
    },
    get_interest_list() {
      let promise = getInterestOverview(this.trade_perPage); return promise.then(res => {
          this.interest_list = res
          // this.trade_currentPage = res["offset"] + 1
          return res
      }).catch(error => {
          console.log(error)
      })
    },
    get_equity_list() {
      getEquityOverview().then(res => {
        console.log(res)
        this.equity_list = res
      }).catch(error => {
        console.log(error)
      })
    },
    get_leverage_list() {
      getLeverageOverview().then(res => {
        console.log(res)
        this.leverage_list = res
      }).catch(error => {
        console.log(error)
      })
    },
    get_profit_list() {
      getProfitOverview().then(res => {
        console.log(res)
        // this.profit_fields = []
        // let fields = res[0]
        // for(var key in fields){
        //   this.profit_fields.push(
        //     {
        //       key: key,
        //       sortable: true
        //     }
        //   )
        // }
        this.usdt_profit_list = res["USDT"]
        this.btc_profit_list = res["BTC"]
        this.eth_profit_list = res["ETH"]
      }).catch(error => {
        console.log(error)
      })
    },
    get_interest_rate() {
      getInterestRateYearly().then(res => {
        this.interest_rate_list = res
      }).catch(error => {
        console.log(error)
      })
    },
    get_funding_rate() {
      getFundingRateYearly().then(res => {
        this.funding_rate_list = res
      }).catch(error => {
        console.log(error)
      })
    },
    get_net_position() {
      getNetPositiontList().then(res => {
        this.net_position_list = res
      }).catch(error => {
        console.log(error)
      })
    },
    get_basis_quarter() {
      getBasisQuarter().then(res => {
        this.basis_data = res
      }).catch(error => {
        console.log(error)
      })
    },
    show_interest_chart() {
      getInterestList().then((res) => {
      this.chartData = this.$echarts.init(document.getElementById('usdt_equityChart'),'dark')
      this.av_interest_rate_list= res["data_map"]
      const data_list = res["data_list"]
      const times = []
      const rateValues = []
      for (let i = 0; i < data_list.length; ++i) {
        rateValues.push(parseFloat(data_list[i]['yearly']))
        times.push(data_list[i]['timestamp'])
      }

      // 配置图表
      const chart_option = {
        backgroundColor: '#2A3042',
        title: {
          text: '',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          bottom: 90
        },
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        xAxis: {
          data: [],
          silent: false,
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          scale:true,
          splitArea: {
            show: false
          }
        },
        series: [
          {
            type: 'line',
            data: [],
            // Set `large` for large data amount
            large: true
          }
        ]
      }
      chart_option.xAxis.data = times
      chart_option.series[0].data = rateValues
      chart_option.title.text = "Interest Yearly(%)"
      
      this.chartData .setOption(chart_option)

      // 将 ECharts 实例保存在数据中
       
      }).catch((error) => {
        console.log(error)
      })
    },
    show_basis_chart() {
      getBasisList(this.basis_perPage, this.interval_perPage, this.coin).then((res) => {
      this.chartDataBasis = this.$echarts.init(document.getElementById('basisChart'),'dark')
      // this.basis_list= res[]
      const data_list = res["basis_list"]
      const apr = res["apr"]
      const times = []
      const rateValues = []
      for (let i = 0; i < data_list.length; ++i) {
        rateValues.push(parseFloat(data_list[i]['basis']))
        times.push(data_list[i]['timestamp'])
      }

      // 配置图表
      const chart_option = {
        backgroundColor: '#2A3042',
        title: {
          text: '',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          bottom: 90
        },
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        xAxis: {
          data: [],
          silent: false,
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          scale:true,
          splitArea: {
            show: false
          }
        },
        series: [
          {
            type: 'line',
            data: [],
            // Set `large` for large data amount
            large: true
          }
        ]
      }
      chart_option.xAxis.data = times
      chart_option.series[0].data = rateValues
      chart_option.title.text =  apr
      
      this.chartDataBasis.setOption(chart_option)

      // 将 ECharts 实例保存在数据中
       
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  mounted() {
    console.log("hhhhhhhhhhhhh")
    this.get_profit_list()
    this.get_equity_list()
    this.get_leverage_list()
    this.get_interest_list()
    this.get_interest_rate()
    this.get_funding_rate()
    this.show_interest_chart()
    this.get_net_position()
    this.show_basis_chart()
    this.get_basis_quarter()
  },
  destroyed(){
            //console.log("销毁-----------------------之后");
        },
  beforeDestroy(){
    clearInterval(this.my_timer)
  }
};

</script>
<template>
  <Layout>
    <PageHeader
      :title="title"
    />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              margin汇总
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="equity_list"
                  :fields="equity_fields"
                />
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              净头寸
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="net_position_list"
                  :fields="net_position_field"
                />
              </div>
          </div>
        </div>
      </div>
    </div>



    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              Profit(USDT)
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="usdt_profit_list"
                  :fields="profit_fields"
                >
                <template #cell(本金)="row">
                 {{ row.value | formatNumber }}
                </template>
                <template #cell(最新净值)="row">
                 {{ row.value | formatNumber }}
                </template>
                <template #cell(累计收益率（APR）)="row">
                  <span :style="{color: positiveNegativeColor('累计收益率（APR）', row.value)}">{{ row.value }}</span>
                </template>
                <template #cell(瞬时收益率（APR）)="row">
                  <span :style="{color: positiveNegativeColor('瞬时收益率（APR）', row.value)}">{{ row.value }}</span>
                </template>
                <template #cell(1天收益率（APR）)="row">
                  <span :style="{color: positiveNegativeColor('1天收益率（APR）', row.value)}">{{ row.value }}</span>
                </template>
                <template #cell(3天收益率（APR）)="row">
                  <span :style="{color: positiveNegativeColor('3天收益率（APR）', row.value)}">{{ row.value }}</span>
                </template>
              </b-table>
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              Profit(BTC)
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="btc_profit_list"
                  :fields="profit_fields"
                >
                <!-- <template #cell(本金)="row">
                 {{ row.value | formatNumber }}
                </template>
                <template #cell(最新净值)="row">
                 {{ row.value | formatNumber }}
                </template> -->
                <template #cell(累计收益率（APR）)="row">
                  <span :style="{color: positiveNegativeColor('累计收益率（APR）', row.value)}">{{ row.value }}</span>
                </template>
                <template #cell(瞬时收益率（APR）)="row">
                  <span :style="{color: positiveNegativeColor('瞬时收益率（APR）', row.value)}">{{ row.value }}</span>
                </template>
                <template #cell(1天收益率（APR）)="row">
                  <span :style="{color: positiveNegativeColor('1天收益率（APR）', row.value)}">{{ row.value }}</span>
                </template>
                <template #cell(3天收益率（APR）)="row">
                  <span :style="{color: positiveNegativeColor('3天收益率（APR）', row.value)}">{{ row.value }}</span>
                </template>
              </b-table>
              </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              Profit(ETH)
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="eth_profit_list"
                  :fields="profit_fields"
                >
                <!-- <template #cell(本金)="row">
                 {{ row.value | formatNumber }}
                </template>
                <template #cell(最新净值)="row">
                 {{ row.value | formatNumber }}
                </template> -->
                <template #cell(累计收益率（APR）)="row">
                  <span :style="{color: positiveNegativeColor('累计收益率（APR）', row.value)}">{{ row.value }}</span>
                </template>
                <template #cell(瞬时收益率（APR）)="row">
                  <span :style="{color: positiveNegativeColor('瞬时收益率（APR）', row.value)}">{{ row.value }}</span>
                </template>
                <template #cell(1天收益率（APR）)="row">
                  <span :style="{color: positiveNegativeColor('1天收益率（APR）', row.value)}">{{ row.value }}</span>
                </template>
                <template #cell(3天收益率（APR）)="row">
                  <span :style="{color: positiveNegativeColor('3天收益率（APR）', row.value)}">{{ row.value }}</span>
                </template>
              </b-table>
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              Interest&Profit
            </h4>
            <label class="d-inline-flex align-items-center">
               Recent&nbsp;
              <b-form-select
                v-model="trade_perPage"
                size="sm"
                :options="trade_pageOptions"
                @change="get_interest_list"
              />&nbsp;days
            </label>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="interest_list"
                  :fields="interest_fields">
                <template #cell(equity_usdt)="row">
                 {{ row.value | formatNumber }}
                </template>
                <template #cell(total)="row">
                  <span :style="{color: positiveNegativeColor('total', row.value)}">{{ row.value }}</span>
                </template>
                <template #cell(funding_profit)="row">
                  <span :style="{color: positiveNegativeColor('funding_profit', row.value)}">{{ row.value }}</span>
                </template>
              </b-table>
                <!-- /> -->
              </div>
          </div>
        </div>
      </div>
    </div>
    

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              interest cost summary
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="interest_rate_list"
                  :fields="rate_field"
                />
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              funding income summary
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="funding_rate_list"
                  :fields="rate_field"
                />
              </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row" v-resize @resize="onResize">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
            杠杠借贷利率
            </h4>
            <div id="usdt_equityChart" style="height:400px;"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              平均利率
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="av_interest_rate_list"
                  :fields="av_rate_field"
                />
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-resize @resize="onResizeBasis">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
            基差
            </h4>
            <label class="d-inline-flex align-items-center">
               &nbsp;
              <b-form-select
                v-model="basis_perPage"
                size="md"
                :options="basis_pageOptions"
                @change="show_basis_chart"
              />&nbsp;    


              &nbsp;
              <b-form-select
                v-model="interval_perPage"
                size="md"
                :options="interval_pageOptions"
                @change="show_basis_chart"
              />&nbsp;

              &nbsp;
              <b-form-select
                v-model="coin"
                size="md"
                :options="coinOptions"
                @change="show_basis_chart"
              />&nbsp;

            </label>
            <div id="basisChart" style="height:400px;"></div>
            <div>
                <b-table
                  hover
                  :items="basis_data"
                />
              </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>